export type MemberRole = 'PASTOR' | 'DEACON' | 'ANNOITED' | 'MEMBER'

export type FamilyRelation =
  | 'FATHER'
  | 'MOTHER'
  | 'SON'
  | 'DAUGHTER'
  | 'SPOUSE'
  | 'BROTHER'
  | 'SISTER'
  | 'GUARDIAN'
  | 'OTHER'

export enum memberRoles {
  PASTOR = 'Pastor',
  DEACON = 'Deacon',
  ANNOITED = 'Annoited',
  MEMBER = 'Member',
}

export type MemberCreateInput = {
  name: string
  address: {
    street?: string
    city?: string
    province?: string
    postal?: string
  }
  phone?: string
  email?: string
  etransferEmail?: string | null
  noEmail: boolean
  familyMembers?: Array<{ memberId: string; relation: FamilyRelation }>
  churchId: string
  role: MemberRole
}

type MemberResponse = {
  _id: string
  name: string
  address: {
    street?: string
    city?: string
    province?: string
    postal?: string
  }
  phone?: string
  email?: string
  etransferEmail?: string | null
  noEmail: boolean
  familyMembers?: Array<{ memberId: string; relation: FamilyRelation }>
  churchId: string
  role: MemberRole
  active: boolean
  createdAt?: string
  updatedAt?: string
}

export type Member = MemberResponse

export type MemberUpdateInput = {
  _id: string
  name: string
  address: {
    street: string
    city: string
    province: string
    postal: string
  }
  phone?: string
  email?: string
  etransferEmail?: string | null
  noEmail: boolean
  familyMembers?: Array<{ memberId: string; relation: FamilyRelation }>
  churchId: string
  role: MemberRole
  active: boolean
}
